import { Modal } from "react-bootstrap";
import { RiCloseLargeFill } from "react-icons/ri";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { useState } from "react";
import ProfileServices from "../../../services/ProfileServices";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
    .required("Mobile number is required"),
  nike_name: Yup.string().required("Nike name is required"),
  location: Yup.string().required("Location is required"),
});

const EditProfileModal = ({ show, onClose, profile, onUpdated }) => {
  const profileApi = new ProfileServices();
  const [isLoading, setIsLoading] = useState(false);

  const initialValues = {
    name: profile?.name ?? "",
    mobile: profile?.mobile ?? "",
    nike_name: profile?.nike_name ?? "",
    location: profile?.location ?? "",
  };

  return (
    <Modal show={show} onHide={onClose} centered backdrop="static" keyboard={false}>
      <div className="modal-header border-0 pb-0">
        <h5 className="modal-title">Edit Profile</h5>
        <button className="btn" onClick={onClose}>
          <RiCloseLargeFill size={20} />
        </button>
      </div>
      <hr className="my-1" />

      <Formik
        enableReinitialize
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          setIsLoading(true);
          profileApi
            .updateProfile(values)
            .then((res) => {
              if (res.isSuccess) {
                toast.success(res.message || "Profile updated");
                onUpdated?.(res.data);
                onClose();
              } else {
                toast.error(res.message || "Failed to update profile");
              }
            })
            .catch((err) => {
              console.error("updateProfile error:", err);
              toast.error(err?.response?.data?.message || "Failed to update profile");
            })
            .finally(() => {
              setIsLoading(false);
              setSubmitting(false);
            });
        }}
      >
        {({ errors, touched, isSubmitting, setFieldValue }) => (
          <Form className="addAdmin-form">
            <Modal.Body className="pt-2">
              <div className="form-group mb-2">
                <label className="form-label mb-0">
                  Name <span className="required-asterisk">*</span>
                </label>
                <div className="input-wrapper">
                  <Field
                    type="text"
                    name="name"
                    placeholder="Enter name"
                    className={`form-input ${errors.name && touched.name ? "input-error" : ""}`}
                  />
                </div>
                <ErrorMessage name="name">
                  {(msg) => <div className="admin_error-text">{msg}</div>}
                </ErrorMessage>
              </div>

              <div className="form-group mb-2">
                <label className="form-label mb-0">
                  Mobile Number <span className="required-asterisk">*</span>
                </label>
                <div className="input-wrapper">
                  <Field
                    type="text"
                    name="mobile"
                    placeholder="Enter mobile number"
                    className={`form-input ${errors.mobile && touched.mobile ? "input-error" : ""}`}
                    onChange={(e) => {
                      const value = e.target.value;
                      const sanitizedValue = value.replace(/[^0-9]/g, "");
                      setFieldValue("mobile", sanitizedValue);
                      e.preventDefault();
                    }}
                 />
                </div>
                <ErrorMessage name="mobile">
                  {(msg) => <div className="admin_error-text">{msg}</div>}
                </ErrorMessage>
              </div>

              <div className="form-group mb-2">
                <label className="form-label mb-0">
                  Nike Name <span className="required-asterisk">*</span>
                </label>
                <div className="input-wrapper">
                  <Field
                    type="text"
                    name="nike_name"
                    placeholder="Enter nike name"
                    className={`form-input ${
                      errors.nike_name && touched.nike_name ? "input-error" : ""
                    }`}
                  />
                </div>
                <ErrorMessage name="nike_name">
                  {(msg) => <div className="admin_error-text">{msg}</div>}
                </ErrorMessage>
              </div>

              <div className="form-group mb-2">
                <label className="form-label mb-0">
                  Location <span className="required-asterisk">*</span>
                </label>
                <div className="input-wrapper">
                  <Field
                    type="text"
                    name="location"
                    placeholder="Enter location"
                    className={`form-input ${
                      errors.location && touched.location ? "input-error" : ""
                    }`}
                  />
                </div>
                <ErrorMessage name="location">
                  {(msg) => <div className="admin_error-text">{msg}</div>}
                </ErrorMessage>
              </div>

              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="submit"
                  className="add_admin-btn"
                  disabled={isSubmitting || isLoading}
                >
                  {isLoading ? "Saving..." : "Save Changes"}
                </button>
              </div>
            </Modal.Body>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default EditProfileModal;

